// extracted by mini-css-extract-plugin
export default {"inner":"IconLink_inner__281Vh","text":"IconLink_text__kk+Ks"};